import React from 'react';
import { Card } from 'reactstrap';

const ProductDetailCard = ({
  className,
  name,
  description,
  beerStyle,
  mostRecentLot,
  lastThirtyDaysBrewingVolume,
  currentYearsBrewingVolume
}) => (
  <Card className={className}>
    <div className="pa3">
      <h3 className="f4 mt0">
        {name} <span className="f6 em">({beerStyle.name})</span>
      </h3>
      {description && <p>{description}</p>}
    </div>
    <div className="flex bt-divider tc">
      <div className="br-divider pv3 flex-grow-1">
        <h5 className="f6 mt0 mb1">Most recent lot</h5>
        <h6 className="f4 ma0">{mostRecentLot ? `${mostRecentLot.volume}L` : '--'}</h6>
      </div>
      <div className="br-divider pv3 flex-grow-1">
        <h5 className="f6 mt0 mb1">Last month total</h5>
        <h6 className="f4 ma0">{lastThirtyDaysBrewingVolume ? `${lastThirtyDaysBrewingVolume}L` : '--'}</h6>
      </div>
      <div className="pv3 flex-grow-1">
        <h5 className="f6 mt0 mb1">Current year total</h5>
        <h6 className="f4 ma0">{currentYearsBrewingVolume ? `${currentYearsBrewingVolume}L` : '--'}</h6>
      </div>
    </div>
  </Card>
);

export default ProductDetailCard;



// WEBPACK FOOTER //
// ./src/components/productDetailCard/productDetailCard.jsx